import React, { Component } from 'react'
import SelectPlanForm from './forms/SelectPlanForm'
import Wizard from './components/Wizard';
import CompanyDetailsForm from './forms/CompanyDetailsForm';
import PaymentDetailsForm from './forms/PaymentDetailsForm';

import '../../../assets/sass/pages/payment/payment.scss';
import { companyDetailsSchema, paymentDetailsSchema } from './forms/schemas';

class Payment extends Component {
    render() {
        const initialValues = {
            isIndependent: false,
            plan: 'gold',
            company: '',
            address: '',
            country: '',
            state: '',
            city: '',
            zip_code: '',
            cardName: '',
            cardNumber: '',
            cvv: '',
            expiryMonth: '',
            expiryYear: ''
        }
        return (
            <div className="payment-page">
                <Wizard
                    className="payment-wizard absolut-error"
                    initialValues={initialValues}
                    onSubmit={this.handleSubmit}
                >
                    <Wizard.Page
                        title="Select Plan"
                        subtitle="Please select plan type you would be intrested in buying after your trial period is over. You will not be charged any amountuntil your trial period is over"
                        className="select-plan-wizard-page"
                        validate={values => {
                            const errors = {};
                            if (!values.plan) errors.plan = "Required";
                            return errors;
                        }}
                    >
                        <SelectPlanForm initialValues={initialValues} />
                    </Wizard.Page>
                    <Wizard.Page
                        title="Company Details"
                        className="company-details-wizard-page"
                        schema={companyDetailsSchema}
                    >
                        <CompanyDetailsForm initialValues={initialValues} />
                    </Wizard.Page>
                    <Wizard.Page
                        title="Payment Details"
                        subtitle="Dont worry! You will not be charged any amount until your trial period is over"
                        schema={paymentDetailsSchema}
                    >
                        <PaymentDetailsForm initialValues={initialValues} />
                    </Wizard.Page>
                </Wizard>
            </div>
        )
    }

    handleSubmit = (values, actions) => {
        console.log(this.props);
        this.props.history.push({
            pathname: '/dashboard',
            state: { isNew: true }
        });
    }
}

export default Payment